import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Layout from './layout';
import { Router, AppRoutes } from 'modules/router';
import sessionManager from 'utils/managers/sessionManager';
import AppStore from 'AppStore';
//import AppRoutes from 'modules/rouAppRoutes';

class App extends Component {
    constructor() {
        super();
        this.state = AppStore.getAppState();
    }
    componentWillMount() {
        AppStore.on('change', this.onAppStateChange);
    }

    componentWillUnmount() {
        AppStore.removeListener('change', this.onAppStateChange);
    }

    onAppStateChange = () => {
        this.setState(AppStore.getAppState());
    };
    render() {
        return (
            <Router appState={this.state}>
                <Layout appState={this.state} />
            </Router>
        );
    }
}

export default App;

// <div className="App">
//         <header className="App-header">
//           <img src={logo} className="App-logo" alt="logo" />
//           <h1 className="App-title">Welcome to React</h1>
//         </header>
//         <p className="App-intro">
//           To get started, edit <code>src/App.js</code> and save to reload.
//         </p>
//       </div>



// WEBPACK FOOTER //
// ./src/App.js